import WelcomeUserAppevent from '@alme/ui-web/modules/appevent-welcomeuser-onlaunch/src/appevent-welcomeuser-onlaunch'
import { DefaultSettings } from '@alme/ui-web/settings/settings-util';
import objectpath from 'object-path';
import { traceLog } from '../../src/logging';

export default class CustomWelcomeUserAppEvent extends WelcomeUserAppevent{

    constructor(passedSettings: DefaultSettings) 
    {
        super(passedSettings);
    }

    GetWelcomeUserParameters(): { [key: string]: unknown} {
        traceLog(`Preparing welcome message`, 'CustomWelcomeUserAppEvent');
        let props = super.GetWelcomeUserParameters();

        const state = this._store?.getState();
        let newState = Object.assign({}, state);
        
        const stateParams = objectpath.get(newState, this._settings.stateLocations.WelcomeUser.Base);
        const LaunchOffers = stateParams["LaunchOffers"] || "";

        traceLog(`${LaunchOffers.length} launch offers found.`, 'CustomWelcomeUserAppEvent');
        if (LaunchOffers.length !== 0) {
            props["LaunchOffers"] = LaunchOffers;
        }
        
        return props;
    }

}


// WEBPACK FOOTER //
// ./modules/custom-appevent-welcomeuser-onlaunch/custom-appevent-welcomeuser-onlaunch.ts